import React from 'react';

import './Icon.scss';

const Icon = ({ type, theme = 'dark', className = '', ...props }) => {
  return <i className={`wt-icon wt-icon-${type} wt-icon--${theme} ${className}`} {...props} />;
};

export default Icon;
